import React, { Component } from 'react'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const styles = () => {
  return {
    container: {
      width: 'auto',
      position: 'relative',
      backgroundColor: 'white',
      borderRadius: '20px',
      padding: '15px',
      boxShadow: '0 3px 3px #D2D2D2',
      height: 'auto',
      minHeight: '40px',
    },
    imageContainer: {
      left: '15px',
      top: '15px',
      width: '40px',
      height: '40px',
      position: 'absolute',
    },
    image: {
      width: '40px',
      height: '40px',
    },
    content: {
      minHeight: 'auto',
      height: 'auto',
      marginLeft: '50px',
    },
    title: {
      fontSize: '16px',
      fontWeight: '600',
      paddingRight: '60px',
    },
    titleWithoutDescription: {
      marginTop: '10px',
      fontSize: '16px',
      fontWeight: '600',
      paddingRight: '60px',
    },
    description: {
      paddingTop: '3px',
      color: 'grey',
      fontSize: '11px',
    },
    rightLabel: {
      position: 'absolute',
      top: '30%',
      right: '5%',
      textAlign: 'right',
    },
    clickable: {
      cursor: 'pointer',
    },
  }
}

@injectSheet(styles)
class WhiteBox extends Component {
  handleClick = () => {
    const { onClick } = this.props
    if (onClick) {
      onClick()
    }
  }

  render() {
    const {
      classes, title, description, image, rightLabel, onClick,
    } = this.props
    return (
      <div
        className={classNames(classes.container, {
          [classes.clickable]: !!onClick,
        })}
        onClick={this.handleClick}
      >
        <div className={classes.imageContainer}>
          {image && <img className={classes.image} src={image} alt="" />}
        </div>
        <div className={classes.content}>
          <div
            className={classNames({
              [classes.title]: !!description,
              [classes.titleWithoutDescription]: !description,
            })}
          >
            {title}
          </div>
          {description && <div className={classes.description}>{description}</div>}
          {rightLabel && <div className={classes.rightLabel}>{rightLabel}</div>}
        </div>
      </div>
    )
  }
}

WhiteBox.propTypes = {
  title: PropTypes.string,
  classes: PropTypes.object,
  description: PropTypes.string,
  rightLabel: PropTypes.node,
  image: PropTypes.string,
  onClick: PropTypes.func,
}

export default WhiteBox
